import { render, staticRenderFns } from "./OrderCommentsForm.vue?vue&type=template&id=0d354a35&"
import script from "./OrderCommentsForm.vue?vue&type=script&lang=js&"
export * from "./OrderCommentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports